
import mutations from './mutations'
import state from './state'
import actions from './actions'

import images from './product-images'
import variants from './product-variant'
import videos from './product-video'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  modules: {
    images,
    variants,
    videos
  },
}